export const getTableText = (phrase: string, table: string): string =>
  phrase.replace('{tablePhrase}', table);
